import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { CloudFile, CloudFolder } from "@/types/cloud";

interface ListFilesResponse {
  success: boolean;
  files?: CloudFile[];
  folders?: CloudFolder[];
  error?: string;
}

export const useOneDriveFiles = (folderId: string = "root") => {
  const {
    data: response,
    isLoading,
    error,
  } = useQuery<ListFilesResponse>({
    queryKey: ["onedrive-files", folderId],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke("cloud-storage", {
        body: {
          action: "list-files",
          data: {
            provider: "onedrive",
            folderId,
          },
        },
      });

      if (error) {
        throw new Error(error.message || "Failed to list files");
      }

      return data;
    },
    staleTime: 1000 * 60, // 1 minute
  });

  return {
    files: response?.files ?? [],
    folders: response?.folders ?? [],
    isLoading,
    error: error ? (error instanceof Error ? error.message : "Failed to load files") : null,
  };
};
